import { Tabs } from '@mantine/core'
import { IconUsers } from '@tabler/icons-react'
import { FormattedMessage } from 'react-intl'
import { Outlet, useLocation, useNavigate } from 'react-router'
import { RouterPath, WorkspaceNestedPath } from '@/router/paths'
import { FixedPageTitle } from '../layout/PageWithFixedToolbar/FixedPageTitle'
import { PageWithFixedToolbar } from '../layout/PageWithFixedToolbar/PageWithFixedToolbar'
import { useWorkspace } from './WorkspaceContext'

export const WorkspacePage = () => {
  const navigate = useNavigate()
  const location = useLocation()
  const { workspace } = useWorkspace()

  const getCurrentTab = () => {
    const allTabs = Object.values(WorkspaceNestedPath)
    const activeTab = allTabs.find((tab) =>
      location.pathname.endsWith(`/${tab}`)
    )

    return activeTab ?? WorkspaceNestedPath.members
  }

  const currentTab = getCurrentTab()

  const handleTabChange = (value: string | null) => {
    const targetPath = value || WorkspaceNestedPath.members
    void navigate(`${RouterPath.workspace}/${targetPath}`)
  }

  return (
    <PageWithFixedToolbar
      maxWidth={1400}
      toolbar={
        <FixedPageTitle
          title={workspace.name}
          icon={
            <IconUsers
              size={24}
              color="var(--mantine-color-orange-6)"
              stroke={3}
            />
          }
        />
      }
    >
      <Tabs
        value={currentTab}
        mb="xl"
        variant="outline"
        styles={{
          tabLabel: {
            fontWeight: 600
          }
        }}
        onChange={handleTabChange}
      >
        <Tabs.List>
          <Tabs.Tab value={WorkspaceNestedPath.members}>
            <FormattedMessage id="workspace.tabs.members" />
          </Tabs.Tab>

          <Tabs.Tab value={WorkspaceNestedPath.settings}>
            <FormattedMessage id="workspace.tabs.settings" />
          </Tabs.Tab>

          <Tabs.Tab value={WorkspaceNestedPath.apiKeys}>
            <FormattedMessage id="workspace.tabs.apiKeys" />
          </Tabs.Tab>

          <Tabs.Tab value={WorkspaceNestedPath.notifications}>
            <FormattedMessage id="workspace.tabs.notifications" />
          </Tabs.Tab>
        </Tabs.List>
      </Tabs>

      <Outlet />
    </PageWithFixedToolbar>
  )
}
